import { IconMoodSmile, IconMoodEmpty, IconMoodSad } from '@tabler/icons-react';
import { CallStatus, Sentiment } from 'interfaces/Reporting';
import { IQuickRange } from 'components/DateRangeFilter/IQuickRange';

export const callStatusColors = {
  [CallStatus.RESOLVED]: '#6AA952',
  [CallStatus.TRANSFERRED]: '#5976AB',
  [CallStatus.MESSAGE_TAKEN]: '#418CFF',
  [CallStatus.UNRESOLVED]: '#999DA5',
  [CallStatus.INCOMPLETE]: '#E9C149',
  [CallStatus.UNKNOWN]: '#D0DCFA',
};

export const sentimentColors = {
  [Sentiment.POSITIVE]: '#6aa952',
  [Sentiment.NEUTRAL]: '#ebc556',
  [Sentiment.NEGATIVE]: '#c55c31',
};

export const sentimentIcons = {
  [Sentiment.POSITIVE]: IconMoodSmile,
  [Sentiment.NEUTRAL]: IconMoodEmpty,
  [Sentiment.NEGATIVE]: IconMoodSad,
};

export const quickRanges: IQuickRange[] = [
  { label: 'Last 12 months', value: 12, unit: 'months', customValue: '12mo' },
  { label: 'Last 3 months', value: 3, unit: 'months', customValue: '3mo' },
  { label: 'Last 30 days', value: 30, unit: 'days', customValue: '30d' },
  { label: 'Last 7 days', value: 7, unit: 'days', customValue: '7d' },
  { label: 'Last 48 hours', value: 48, unit: 'hours', customValue: '48h' },
  { label: 'Last 24 hours', value: 24, unit: 'hours', customValue: '24h' },
  { label: 'Last hour', value: 1, unit: 'hours', customValue: '1h' },

  // TODO: Implement quarterly date range calculation for reporting
  // The following range would enable "Last quarter" filtering, but needs proper quarter boundary logic
  // Currently disabled due to complex month-to-quarter mapping and potential timezone issues
  //
  // {
  //   label: 'Last quarter',
  //   value: 3,
  //   unit: 'months',
  //   customValue: 'quarter',
  //   getRange: () => {
  //     const now = dayjs();
  //     const currentMonth = now.month();
  //     const startOfQuarter = now
  //       .startOf('month')
  //       .subtract((currentMonth % 3) + 3, 'month');
  //     return {
  //       from: startOfQuarter.toDate(),
  //       to: startOfQuarter.add(3, 'month').subtract(1, 'minute').toDate(),
  //     };
  //   }
  // },
] as const;

export const CALLS_PAGE_SIZE = 10;
export const DATE_RANGE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ';
export const DATE_INPUT_TIME_FORMAT = 'MMM D, YYYY hh:mm';
